import { useCallback } from 'react'

import { useTurnFeedbackToRoadmapItemMutation } from '~generated/hooks'
import { TurnFeedbackToRoadmapItemMutation } from '~generated/operations'
import { productBoardRoadmapDtoTypename } from '~lib/apollo/typenames'
import { modifyRoadmapItemsConnection } from '~modules/productRoadmapItems/usecases/useRoadmapItemsGroups/useRoadmapItemsGroups'

type Props = {
  onCompleted?: (data: TurnFeedbackToRoadmapItemMutation) => void
}
export default function useTurnFeedbackPostToRoadmapItem({ onCompleted }: Props = {}) {
  const [turnFeedbackToRoadmapItemMutation, options] = useTurnFeedbackToRoadmapItemMutation()

  const turnFeedbackToRoadmapItem = useCallback(
    (roadmapId: string, feedbackPostId: string) => {
      return turnFeedbackToRoadmapItemMutation({
        variables: {
          input: {
            roadmapId,
            feedbackPostId,
          },
        },
        update: (cache, { data }) => {
          const roadmapId = cache.identify({
            id: data.turnFeedbackPostIntoProductBoardItem.roadmapId,
            __typename: productBoardRoadmapDtoTypename,
          })

          const roadmapItem = data.turnFeedbackPostIntoProductBoardItem

          cache.modify({
            id: roadmapId,
            fields: {
              items: modifyRoadmapItemsConnection({
                connectionFilter: { roadmapIds: [roadmapId] },
                addItems: [roadmapItem],
              }),
            },
          })
        },
        onCompleted,
      })
    },
    [turnFeedbackToRoadmapItemMutation, onCompleted]
  )

  return [turnFeedbackToRoadmapItem, options] as const
}
